import { TReduxActions } from '../../types/redux';
import { ISort } from '../../types/sort';
import { ESortActionTypes } from '../../actions/sort';

export const defaultSortState = [];

export function sortReducer(state: ISort[] = defaultSortState, action: TReduxActions) {
  switch (action.type) {
    case ESortActionTypes.SetActiveSort: {
      return state.map(item => ({ ...item, isSelected: item.type === action.payload }));
    }

    case ESortActionTypes.SetSortOptions: {
      return action.payload;
    }

    default:
      return state;
  }
}
